import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withStyles from '@material-ui/core/styles/withStyles';
import HexColourPicker from './HexColourPicker';
import { Typography, TextField, FormControlLabel, Checkbox, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

class EditLayer extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            color: '#3BB2D0'
        };
    }

    render () {
        const { classes, onClose } = this.props;
        return (
            <div className={classes.root} onClick={(e) => {
                if (e.target.classList.contains(classes.root)) {
                    onClose();
                }
            }}>
                <div className={classes.modal}>
                    <div className={classes.title}>
                        <Typography
                            variant="h6"
                            color="textPrimary"
                        >
                            Customise drawn layer
                        </Typography>
                        <CloseIcon
                            fontSize="small"
                            className={classes.exitIcon}
                            onClick={(e) => onClose()}
                        />
                    </div>
                    <div className={classes.subtitle}>
                        <Typography
                            variant="subtitle2"
                            color="textPrimary"
                        >
                            Edit drawn layer colour
                        </Typography>
                    </div>
                    {/* <div className={classes.outline}> */}
                    <HexColourPicker
                        color={this.state.color}
                        changeColor={(hex) => this.setState({ color: hex })}
                    />
                    {/* <div className={classes.text}>
                            <Typography
                                variant="caption"
                                color="textPrimary"
                            >
                                Choose a colour for the custom drawn area. Any text colour will be adjusted automatically.
                            </Typography>
                        </div>
                    </div> */}
                    <hr className={classes.divider} />
                    <div className={classes.subtitle}>
                        <Typography
                            variant="subtitle2"
                            color="textPrimary"
                        >
                            Edit drawn layer name
                        </Typography>
                    </div>
                    <div className={classes.editLayerNameInput}>
                        <TextField
                            // label="Edit drawn layer name"
                            variant="outlined"
                            color="secondary"
                            fullWidth
                            InputLabelProps={{
                                classes: {
                                    root: classes.cssLabel,
                                    focused: classes.cssFocused
                                },
                                shrink: true
                            }}
                            InputProps={{
                                classes: {
                                    root: classes.cssOutlinedInput,
                                    focused: classes.cssFocused,
                                    notchedOutline: classes.notchedOutline
                                }
                            }}
                        />
                    </div>
                    <div className={classes.defaultName}>
                        <FormControlLabel
                            label={<Typography
                                variant="subtitle1"
                                color="textPrimary"
                            >
                                Use default name for custom layer
                            </Typography>}
                            labelPlacement="right"
                            control={<Checkbox color="secondary" defaultChecked />}
                        />
                    </div>
                    <div className={classes.row}>
                        <Button
                            autoCapitalize={false}
                            size="small"
                            variant="outlined"
                            disableElevation
                            onClick={(e) => onClose()}
                        >
                            Cancel
                        </Button>
                        <Button
                            autoCapitalize={false}
                            size="small"
                            variant="contained"
                            color="primary"
                            disableElevation
                        >
                            Save
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

const style = (theme) => ({
    root: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        background: 'rgb(0, 0, 0, 0.4)',
        display: 'grid',
        placeItems: 'center',
        top: 0,
        left: 0,
        zIndex: 1
    },
    modal: {
        // height: '600px',
        width: '300px',
        backgroundColor: theme.palette.background.main,
        padding: '5px 15px 10px 15px',
        // borderRadius: '6px',
        border: `1px solid ${theme.palette.background.contrastText}`,
        zIndex: 2
    },
    title: {
        paddingBottom: '10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    exitIcon: {
        color: theme.palette.background.contrastText,
        cursor: 'pointer'
    },
    subtitle: {
        paddingBottom: '10px'
    },
    outline: {
        background: theme.palette.primary.main,
        padding: '4px 10px 10px 10px',
        borderRadius: '6px',
        marginTop: '10px'
    },
    text: {
        paddingBottom: '5px'
    },
    editLayerNameInput: {
        // marginTop: '10px'
    },
    divider: {
        margin: '10px 0 10px 0'
    },
    defaultName: {
        color: '#ffffff',
        margin: '0 0 10px 0'
    },
    row: {
        display: 'grid',
        gridTemplateColumns: 'calc(50% - 5px) calc(50% - 5px)',
        columnGap: '10px'
    },
    cssLabel: {
        color : `${theme.palette.primary.contrastText} !important`
    },
    cssOutlinedInput: {
        '& > input': {
            padding: '10px 10px !important',
            fontWeight: 400,
            fontSize: '14px'
        },
        '&$cssFocused $notchedOutline': {
            borderColor: `${theme.palette.background.contrastText} !important`
        }
    },
    cssFocused: {},
    notchedOutline: {
        borderWidth: '1px',
        borderColor: `${theme.palette.background.contrastText} !important`
    }
});

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => ({
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(EditLayer);